import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

type MenusProps = {
  isDarkMode: boolean;
};

const Menus = ({ isDarkMode }: MenusProps) => {
  const [activeMenu, setActiveMenu] = useState<string>("dashboard");
  const location = useLocation();
  let fullPath = location.pathname.split("/");
  let currentPath = fullPath[1];

  return (
    <div
      className={`w-60 min-h-screen fixed ${
        isDarkMode ? "bg-[#161B22]" : "bg-gray-100"
      } border-r ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
    >
      <div
        className={`p-4 border-solid border-b ${
          isDarkMode ? "border-gray-700" : "border-gray-200"
        }`}
      >
        <div className="flex items-center">
          <img src="/images/chiksoft_blue.png" alt="logo" width={40} />
          <h1 className="text-2xl font-bold text-[#00a0eb]">Chik Soft</h1>
        </div>

        {/* <p
          className={`text-sm ${
            isDarkMode ? "text-gray-400" : "text-gray-600"
          }`}
        >
          Gestion Scolaire
        </p> */}
      </div>
      <nav className="mt-6">
        <Link
          to="/"
          onClick={() => setActiveMenu("dashboard")}
          className={`p-3 mx-3 flex items-center rounded-lg mb-2 cursor-pointer ${
            currentPath === ""
              ? "bg-blue-500 text-white"
              : isDarkMode
              ? "hover:bg-gray-700"
              : "hover:bg-gray-200"
          } `}
        >
          <i className="fas fa-th-large mr-3"></i>
          <span>Tableau de bord</span>
        </Link>
        <Link
          to="/eleves"
          onClick={() => setActiveMenu("students")}
          className={`p-3 mx-3 flex items-center rounded-lg mb-2 cursor-pointer ${
            currentPath === "eleves"
              ? "bg-blue-500 text-white"
              : isDarkMode
              ? "hover:bg-gray-700"
              : "hover:bg-gray-200"
          } `}
        >
          <i className="fas fa-user-graduate mr-3"></i>
          <span>Élèves</span>
        </Link>
        {/* <div
          className={`p-3 mx-3 flex items-center rounded-lg mb-2 cursor-pointer hover:${
            isDarkMode ? "bg-gray-700" : "bg-gray-200"
          }`}
        >
          <i className="fas fa-chalkboard-teacher mr-3"></i>
          <span>Personnels</span>
        </div> */}
        <Link
          to="/attendance"
          onClick={() => setActiveMenu("attendance")}
          className={`p-3 mx-3 flex items-center rounded-lg mb-2 cursor-pointer ${
            currentPath === "attendance"
              ? "bg-blue-500 text-white"
              : isDarkMode
              ? "hover:bg-gray-700"
              : "hover:bg-gray-200"
          } `}
        >
          <i className="fas fa-clipboard-check mr-3"></i>
          <span>Présences</span>
        </Link>
        <Link
          to={"/paiement"}
          onClick={() => setActiveMenu("paiement")}
          className={`p-3 mx-3 flex items-center rounded-lg mb-2 cursor-pointer ${
            currentPath === "paiement"
              ? "bg-blue-500 text-white"
              : isDarkMode
              ? "hover:bg-gray-700"
              : "hover:bg-gray-200"
          } `}
        >
          <i className="fas fa-credit-card mr-3"></i>
          <span>Paiements</span>
        </Link>
        <Link
          to={"/message"}
          onClick={() => setActiveMenu("message")}
          className={`p-3 mx-3 flex items-center rounded-lg mb-2 cursor-pointer ${
            currentPath === "message"
              ? "bg-blue-500 text-white"
              : isDarkMode
              ? "hover:bg-gray-700"
              : "hover:bg-gray-200"
          } `}
        >
          <i className="fas fa-comments mr-3"></i>
          <span>Communications</span>
        </Link>
        {/* <div
          className={`p-3 mx-3 flex items-center rounded-lg mb-2 cursor-pointer hover:${
            isDarkMode ? "bg-gray-700" : "bg-gray-200"
          }`}
        >
          <i className="fas fa-calendar-alt mr-3"></i>
          <span>Événements</span>
        </div> */}
        <Link
          to={"/parametre"}
          onClick={() => setActiveMenu("parametre")}
          className={`p-3 mx-3 flex items-center rounded-lg mb-2 cursor-pointer ${
            currentPath === "parametre"
              ? "bg-blue-500 text-white"
              : isDarkMode
              ? "hover:bg-gray-700"
              : "hover:bg-gray-200"
          } `}
        >
          <i className="fas fa-cog mr-3"></i>
          <span>Paramètres</span>
        </Link>
      </nav>
      <div className="absolute bottom-4 w-full px-3">
        <button
          className={`p-3 w-full flex items-center rounded-lg text-red-500 cursor-pointer hover:${
            isDarkMode ? "bg-gray-700" : "bg-gray-200"
          } !rounded-button whitespace-nowrap`}
        >
          <i className="fas fa-sign-out-alt mr-3"></i>
          <span>Déconnexion</span>
        </button>
      </div>
    </div>
  );
};

export default Menus;
